export function Background() {
  return (
    <div className="pointer-events-none absolute inset-0 z-[1] h-full w-full overflow-hidden opacity-100 [-webkit-mask-image:url('/background/lines1.svg'),url('/background/lines2.svg'),url('/background/lines3.svg')] [-webkit-mask-position:0_0,0_0,0_0] [-webkit-mask-repeat:repeat,repeat,repeat] [animation:heartbeat_2s_ease-in-out_alternate_infinite] [background:var(--bg-gradient,linear-gradient(to_right,var(--blue),var(--purple)))] [filter:saturate(2)] [mask-image:url('/background/lines1.svg'),url('/background/lines2.svg'),url('/background/lines3.svg')] [mask-position:0_0,0_0,0_0] [mask-repeat:repeat,repeat,repeat]" />
  )
}

export default Background
